import { TrendingUp, TrendingDown } from 'lucide-react';

/**
 * MonthCard - Aylık Gelir/Gider Kartı
 * InvoiceMonthCard yapısı temel alındı
 */
const AyKarti = ({
    month,
    index,
    isSelected,
    onSelect,
    formatCompact,
    getMonthShort
}) => {
    const monthNet = (month.income || 0) - (month.expense || 0);
    const isPositive = monthNet >= 0;

    const handleClick = () => {
        onSelect(index);
    };


    return (
        <div
            onClick={handleClick}
            className={`shrink-0 w-[150px] p-4 rounded-2xl transition-all duration-300 text-left cursor-pointer ${isSelected
                ? 'bg-gradient-to-br from-primary to-primary/80 text-white shadow-xl shadow-primary/30 scale-105'
                : 'bg-white/60 dark:bg-white/10 backdrop-blur-xl border border-white/20 hover:bg-white/80 dark:hover:bg-white/20 hover:shadow-lg hover:scale-[1.02]'
                }`}
            style={{
                backdropFilter: isSelected ? 'none' : 'blur(12px)',
                WebkitBackdropFilter: isSelected ? 'none' : 'blur(12px)',
            }}
        >
            <p className={`text-sm font-semibold mb-2 ${isSelected ? 'text-white/90' : 'text-text-primary'}`}>
                {getMonthShort(month.month)}
            </p>
            <p className={`text-xl font-bold mb-1 ${isSelected ? 'text-white' : 'text-text-primary'}`}>
                ₺{formatCompact(month.income)}
            </p>
            <div className="flex items-center gap-1.5">
                <div className={`w-5 h-5 rounded-full flex items-center justify-center ${isSelected
                    ? 'bg-white/20'
                    : isPositive ? 'bg-success/10' : 'bg-error/10'
                    }`}>
                    {isPositive ? (
                        <TrendingUp size={12} className={isSelected ? 'text-white' : 'text-success'} />
                    ) : (
                        <TrendingDown size={12} className={isSelected ? 'text-white' : 'text-error'} />
                    )}
                </div>
                <span className={`text-sm font-medium ${isSelected ? 'text-white/90' : isPositive ? 'text-success' : 'text-error'
                    }`}>
                    {isPositive ? '+' : ''}₺{formatCompact(monthNet)}
                </span>
            </div>
        </div>
    );
};

export default AyKarti;
